import React from 'react';

import { staticRoutesWithCustomSidebar } from 'Deer/constants/staticRoutesWithCustomSidebar';
import { Redirect, Route, Switch } from 'react-router-dom';
import QuestionListSidepanel from 'screens/admin/common/TemplateCommons/QuestionListSidepanel';
import { QuestionListSidePanelProvider } from 'screens/admin/common/TemplateCommons/QuestionListSidepanel/context/QuestionListSidepanelContext';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { getEngagementTemplateListRoute } from 'constants/helper';
import { routes } from 'constants/routes';

import { EngagementTemplateProvider } from './Context/EngagementContext';
import EngagementTemplatePreview from './EngagementTemplatePreview';
import EngagementTemplateForm from './TemplateForm';

/**
 * @deprecated 09-01-2025 confirm before deletion: https://peoplemesh.slack.com/archives/C01AYG5JEAF/p1736420210454079
 */
const EngagementTemplate = () => (
  <EngagementTemplateProvider>
    <QuestionListSidePanelProvider>
      <Switch>
        <Route
          exact
          path={
            checkNewNavEnabled()
              ? staticRoutesWithCustomSidebar.engagementTemplateCreation
              : routes.template.engagement.index
          }
          component={EngagementTemplateForm}
        />
        <Route
          exact
          path={
            checkNewNavEnabled()
              ? staticRoutesWithCustomSidebar.engagementTemplatePreview
              : routes.template.engagement.preview
          }
          component={EngagementTemplatePreview}
        />
        <Redirect to={getEngagementTemplateListRoute()} />
      </Switch>
      <QuestionListSidepanel source="engagement" />
    </QuestionListSidePanelProvider>
  </EngagementTemplateProvider>
);

export default EngagementTemplate;
